import React, { Component, Fragment } from 'react'
import Cookies from 'js-cookie'
import PropTypes from 'prop-types'

import Button from '../Button/Button'
import Modal from '../../Modal'
import Input from '../InputFloatingLabel'
import RDGateway from '../../../gateways/RDGateway'
import { telephoneMask } from '../../../utils/masks'
import { redirectWithCookies } from '../../../utils/Utm'

const FIELDS = ['name', 'email', 'telephone', 'activity']

const ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
}

class DemoFormB2B extends Component {
    static propTypes = {
        b2b: PropTypes.bool,
        contaAzul: PropTypes.bool,
        className: PropTypes.string,
        radius: PropTypes.string,
        partnerId: PropTypes.string,
        buttonOnly: PropTypes.bool,
        modalButtonText: PropTypes.string,
    }

    static defaultProps = {
        b2b: false,
        contaAzul: false,
        radius: 'half-rounded',
        buttonOnly: false,
    }

    constructor(props) {
        super(props)

        this.rdGateway = new RDGateway()
        this.state = this.getInitialState(props)

        globalThis.optimizeOpenPopupB2B = () => {
            this.setState({ showDemoModal: true });
        }
    }

    getInitialState(props) {
        const initialObject = {
            showDemoModal: false,
            company: '',
            name: '',
            email: '',
            telephone: '',
            activity: '',
            partnerId: props.partnerId
        }
        FIELDS.forEach(campo => {
            initialObject[`${campo}Error`] = false
            initialObject[`${campo}Typing`] = false
        })
        return initialObject
    }

    setDataByCookie() {
        this.setState({
            partnerId: Cookies.get('leaderPartnerId') || this.state.partnerId || ''
        })
    }

    openDemoModal(e) {
        e.preventDefault()

        this.setState({
            showDemoModal: true
        })
    }

    closeDemoModal() {
        this.setState({
            showDemoModal: false
        })
    }

    handleChange(e) {
        const name = e.target.id
        let value = e.target.value
        let company = `${this.state.name} - ${this.state.email}`

        if (name === 'telephone') {
            value = telephoneMask(value)
        } else if (name === 'name') {
            company = value + ' - ' + this.state.email
        } else if (name === 'email') {
            company = this.state.name + ' - ' + value
        }

        this.setState({
            [name]: value,
            company,
            [`${name}Error`]: false,
            [`${name}Typing`]: true,
        })
    }

    handlerEnterpriseActivity(tipo) {
        this.setState({ 'activity': tipo })
    }

    getSelectedActivity(selected) {
        return this.state.activity === selected ? 'active' : ''
    }


    handleActivityChange = (activity) => {
        this.setState({ selectedActivity: activity });
    }

    validation() {
        const newState = {}

        const regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/
        FIELDS.forEach(campo => {
            newState[`${campo}Error`] = !this.state[campo]
            switch (campo) {
                case 'email': {
                    newState[`${campo}Error`] = !this.validateEmail(this.state[campo])
                    break
                }
                case 'telephone': {
                    newState[`${campo}Error`] = !regexTelephone.test(this.state[campo])
                    break
                }
            }
        })
        this.setState(newState)
        const lista = Object.values(newState)
        return lista.every(value => (!value))
    }

    validateEmail(email) {
        const regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regexEmail.test(email.toLowerCase())
    }

    submitForm(e) {
        e.preventDefault()
        if (this.validation()) {
            const data = {
                conversion_identifier: 'fale-consultor-b2b',
                'cf_tipo_de_conversao': 'Solicitou demonstração E-commerce B2B',
                company_name: this.state.company,
                name: this.state.name,
                email: this.state.email,
                personal_phone: this.state.telephone,
                'cf_atividade_da_empresa': this.state.activity,
                event_action: 'solicitou_demo',
                event_label: 'ecommerce_b2b',
            }

            if (this.state.partnerId) {
                data.conversion_identifier = 'canais-lp'
                data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId
            }


            let redirectLink = 'https://mercos.com/tp/solicitou-demo-b2b/'
            if (this.state.activity === ACTIVITY.rep || this.state.activity === ACTIVITY.outra) {
                redirectLink = 'https://materiais.mercos.com/tp-demo-b2b';
            } else if (this.props.euCommerce) {
                redirectLink = 'https://mercos.com/tp/tp-parceria-mercos-eucommerce/'
            } else if (this.props.b2bPromo) {
                redirectLink = 'https://materiais.mercos.com/tp-clientes-demo-b2b'
            }
            this.rdGateway.sendToRDStation(data, redirectLink)

        }
    }

    componentDidMount() {
        this.setDataByCookie()
    }

    getDemoModal() {
        return (
            <Modal callbackCloseModal={() => this.closeDemoModal()} >
                <div className='container-form-modal'>
                    {this.getForm()}
                </div>
            </Modal>
        )
    }


    handleActivityDropdownClick = (e) => {
        const dropdown = e.currentTarget.nextElementSibling;
        const button = e.currentTarget;

        dropdown.classList.toggle('show');
        button.classList.toggle('expanded');
    }

    handleActivityOptionClick = (activity) => {
        const button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
        const dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

        dropdown.classList.remove('show');
        button.classList.remove('expanded');
        button.classList.add('option-selected');
        button.textContent = activity;

        this.handlerEnterpriseActivity(activity);
    }

    getForm() {
        return (
            <Fragment>
                <div className='form-container' >
                    {this.props.title === false ? null : (
                        <div className='form-title'>{this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'} {this.props.euCommerce ? this.props.euCommerce : ''} {this.props.b2bPromo ? this.props.b2bPromo : ''}</div>
                    )}
                    <form action='.' method='POST' className='new-form' onSubmit={e => this.submitForm(e)}>
                        <Input type="hidden" name="company" value={this.state.company} />

                        <Input id="name" value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} placeholder={'Nome'} />

                        <Input id="email" value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} placeholder={'E-mail profissional'} />

                        <Input id="telephone" value={this.state.telephone} onChange={e => this.handleChange(e)} error={this.state.telephoneError} maxLength="15" placeholder={'Telefone'} />



                        <div className="activity-wrapper">
                            <div className="activity-dropdown-button" onClick={this.handleActivityDropdownClick}>
                                &nbsp;
                            </div>
                            <div className="activity-dropdown">
                                <Button className={this.getSelectedActivity(ACTIVITY.industria)} onClick={() => this.handleActivityOptionClick(ACTIVITY.industria)}><img src="/images/icon-industrias.svg" />Indústrias</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.distribuicao)} onClick={() => this.handleActivityOptionClick(ACTIVITY.distribuicao)}><img src="/images/icon-distribuidoras.svg" />Distribuidoras</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.rep)} onClick={() => this.handleActivityOptionClick(ACTIVITY.rep)}><img src="/images/icon-representates.svg" />Representantes</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.outra)} onClick={() => this.handleActivityOptionClick(ACTIVITY.outra)}><img src="/images/icon-outros.svg" />Outra</Button>

                            </div>
                            <span className='floating-label'>
                                Qual é a atividade da sua empresa?
                            </span>
                            {this.state.activityError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                        </div>


                        <div className='submit-demo-modal'>
                            <Button type='submit' className='new-submit new-button'>solicitar demonstração</Button>
                        </div>
                        {(this.props.showForm || this.props.inline) && <p className="inline-form-trial-info">Teste grátis por 7 dias | Sem cobrança automática</p>}
                    </form>
                </div>
            </Fragment>
        )
    }

    getCTA() {
        return (
            <Fragment>
                <div className='cta-button-form'>
                    {this.getModalButton()}
                    <p className='font-light font-12'>integração com mais de 200 ERPs <span className='cta-text-separator'>| </span>venda 24h por dia, 7 dias por semana <span className='cta-text-separator'>| </span>simples de usar</p>
                </div>

            </Fragment>


        )
    }

    getModalButton() {
        return (
            <Fragment>
                <button
                    href='.'
                    className={`new-button  ${this.props.trialAndDemo ? 'button-secondary' : 'button-primary'}`}
                    onClick={e => this.openDemoModal(e)}
                    title='Peça uma demonstração aos nossos especialistas.'
                >
                    {this.props.modalButtonText || this.props.children || 'peça uma demonstração'}
                </button>
                {this.props.buttonOnly && <p className="button-only-trial-info">Teste grátis por 7 dias | Sem cobrança automática</p>}
            </Fragment>
        )
    }

    getModalLink() {
        return (
            <a
                href='.'
                className={`button-txt ${this.props.darkBg ? 'button-txt-white' : ''}`}
                onClick={e => this.openDemoModal(e)}
                title='Peça uma demonstração aos nossos especialistas.'
            >
                {this.props.modalButtonText || 'conheça o E-commerce B2B ›'}
            </a>
        )
    }

    getTrialAndDemo() {
        return (
            <div className='wrapper-trial-and-demo mobile-only'>
                <button
                    className={`new-button button-primary ${this.props.darkBg ? 'dark-bg' : ''}`}
                    onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')}
                    href='#'
                    title='Cadastre-se no Mercos!'
                >
                    {this.props.trialAndDemo}
                </button>
                {this.getModalButton()}
            </div>
        ) 
    }

    render() {
        return (
            <Fragment>
                <div className="new-form-wrapper new-form-wrapper-b2b" >
                {this.props.modaLink ? this.getModalLink() : this.props.trialAndDemo ? this.getTrialAndDemo() : this.props.buttonOnly ? this.getModalButton() : this.getCTA()}

                    {this.props.showForm &&
                        (
                            <div className="show-full-form">
                                {this.getForm()}
                            </div>
                        )}

                    {this.state.showDemoModal && this.getDemoModal()}
                </div>

            </Fragment>
        )
    }
}

export default DemoFormB2B



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/Forms/DemoFormB2B.jsx